"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: auth/session.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fauth%2Fsession.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginFlowToJSON = exports.loginFlowFromJSON = exports.SessionMetadata = exports.CreateSession = exports.Factor = exports.UserDeviceSession = exports.Session = exports.LoginFlow = void 0;
const login_factor_type_1 = require("../common/login-factor-type");
const masked_alias_1 = require("../common/masked-alias");
const device_1 = require("./device");
const device_check_metadata_1 = require("./device-check-metadata");
const protobufPackage = 'com.step.auth.session.proto';
var LoginFlow;
(function (LoginFlow) {
    LoginFlow["SIGNUP"] = "SIGNUP";
    LoginFlow["RECOVERY"] = "RECOVERY";
    LoginFlow["UNRECOGNIZED"] = "UNRECOGNIZED";
})(LoginFlow || (exports.LoginFlow = LoginFlow = {}));
function createBaseSession() {
    return {
        id: '',
        userId: '',
        flow: LoginFlow.SIGNUP,
        requestedFlow: LoginFlow.SIGNUP,
        requiredFactors: 0,
        factors: [],
        createdAtMs: '0',
        updatedAtMs: '0',
        completedAtMs: '0',
        device: undefined,
        userDevice: undefined,
        metadata: undefined,
    };
}
exports.Session = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            flow: isSet(object.flow) ? loginFlowFromJSON(object.flow) : LoginFlow.SIGNUP,
            requestedFlow: isSet(object.requestedFlow)
                ? loginFlowFromJSON(object.requestedFlow)
                : LoginFlow.SIGNUP,
            requiredFactors: isSet(object.requiredFactors)
                ? globalThis.Number(object.requiredFactors)
                : 0,
            factors: globalThis.Array.isArray(object?.factors)
                ? object.factors.map((e) => exports.Factor.fromJSON(e))
                : [],
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
        };
        if (isSet(object.completedAtMs)) {
            message.completedAtMs = globalThis.String(object.completedAtMs);
        }
        if (isSet(object.device)) {
            message.device = device_1.Device.fromJSON(object.device);
        }
        if (isSet(object.userDevice)) {
            message.userDevice = exports.UserDeviceSession.fromJSON(object.userDevice);
        }
        if (isSet(object.metadata)) {
            message.metadata = device_check_metadata_1.DeviceCheckMetadata.fromJSON(object.metadata);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.flow !== LoginFlow.SIGNUP) {
            obj.flow = loginFlowToJSON(message.flow);
        }
        if (message.requestedFlow !== LoginFlow.SIGNUP) {
            obj.requestedFlow = loginFlowToJSON(message.requestedFlow);
        }
        if (message.requiredFactors !== 0) {
            obj.requiredFactors = Math.round(message.requiredFactors);
        }
        if (message.factors?.length) {
            obj.factors = message.factors.map((e) => exports.Factor.toJSON(e));
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        if (message.completedAtMs !== undefined && message.completedAtMs !== '0') {
            obj.completedAtMs = message.completedAtMs;
        }
        if (message.device !== undefined) {
            obj.device = device_1.Device.toJSON(message.device);
        }
        if (message.userDevice !== undefined) {
            obj.userDevice = exports.UserDeviceSession.toJSON(message.userDevice);
        }
        if (message.metadata !== undefined) {
            obj.metadata = device_check_metadata_1.DeviceCheckMetadata.toJSON(message.metadata);
        }
        return obj;
    },
    create(base) {
        return exports.Session.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSession();
        message.id = object.id ?? '';
        message.userId = object.userId ?? '';
        message.flow = object.flow ?? LoginFlow.SIGNUP;
        message.requestedFlow = object.requestedFlow ?? LoginFlow.SIGNUP;
        message.requiredFactors = object.requiredFactors ?? 0;
        message.factors = object.factors?.map((e) => exports.Factor.fromPartial(e)) || [];
        message.createdAtMs = object.createdAtMs ?? '0';
        message.updatedAtMs = object.updatedAtMs ?? '0';
        message.completedAtMs = object.completedAtMs ?? '0';
        message.device = (object.device !== undefined && object.device !== null)
            ? device_1.Device.fromPartial(object.device)
            : undefined;
        message.userDevice = (object.userDevice !== undefined && object.userDevice !== null)
            ? exports.UserDeviceSession.fromPartial(object.userDevice)
            : undefined;
        message.metadata = (object.metadata !== undefined && object.metadata !== null)
            ? device_check_metadata_1.DeviceCheckMetadata.fromPartial(object.metadata)
            : undefined;
        return message;
    },
};
function createBaseUserDeviceSession() {
    return { isUnrecognized: false, forcedLogoutCount: 0 };
}
exports.UserDeviceSession = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.isUnrecognized)) {
            message.isUnrecognized = globalThis.Boolean(object.isUnrecognized);
        }
        if (isSet(object.forcedLogoutCount)) {
            message.forcedLogoutCount = globalThis.Number(object.forcedLogoutCount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isUnrecognized !== undefined && message.isUnrecognized !== false) {
            obj.isUnrecognized = message.isUnrecognized;
        }
        if (message.forcedLogoutCount !== undefined && message.forcedLogoutCount !== 0) {
            obj.forcedLogoutCount = Math.round(message.forcedLogoutCount);
        }
        return obj;
    },
    create(base) {
        return exports.UserDeviceSession.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserDeviceSession();
        message.isUnrecognized = object.isUnrecognized ?? false;
        message.forcedLogoutCount = object.forcedLogoutCount ?? 0;
        return message;
    },
};
function createBaseFactor() {
    return {
        type: login_factor_type_1.LoginFactorType.INVALID_VERIFICATION_METHOD,
        required: false,
        verifiedAtMs: '0',
        maskedAliases: [],
    };
}
exports.Factor = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? (0, login_factor_type_1.loginFactorTypeFromJSON)(object.type)
                : login_factor_type_1.LoginFactorType.INVALID_VERIFICATION_METHOD,
            required: isSet(object.required) ? globalThis.Boolean(object.required) : false,
            maskedAliases: globalThis.Array.isArray(object?.maskedAliases)
                ? object.maskedAliases.map((e) => masked_alias_1.MaskedAlias.fromJSON(e))
                : [],
        };
        if (isSet(object.verifiedAtMs)) {
            message.verifiedAtMs = globalThis.String(object.verifiedAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== login_factor_type_1.LoginFactorType.INVALID_VERIFICATION_METHOD) {
            obj.type = (0, login_factor_type_1.loginFactorTypeToJSON)(message.type);
        }
        if (message.required !== false) {
            obj.required = message.required;
        }
        if (message.verifiedAtMs !== undefined && message.verifiedAtMs !== '0') {
            obj.verifiedAtMs = message.verifiedAtMs;
        }
        if (message.maskedAliases?.length) {
            obj.maskedAliases = message.maskedAliases.map((e) => masked_alias_1.MaskedAlias.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.Factor.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFactor();
        message.type = object.type ?? login_factor_type_1.LoginFactorType.INVALID_VERIFICATION_METHOD;
        message.required = object.required ?? false;
        message.verifiedAtMs = object.verifiedAtMs ?? '0';
        message.maskedAliases = object.maskedAliases?.map((e) => masked_alias_1.MaskedAlias.fromPartial(e)) || [];
        return message;
    },
};
function createBaseCreateSession() {
    return {
        flow: LoginFlow.SIGNUP,
        requestedFlow: LoginFlow.SIGNUP,
        requiredFactors: 0,
        requiredFactorTypes: [],
        optionalFactorTypes: [],
        supportsUnverifiedAliases: false,
    };
}
exports.CreateSession = {
    fromJSON(object) {
        const message = {
            requiredFactors: isSet(object.requiredFactors)
                ? globalThis.Number(object.requiredFactors)
                : 0,
            requiredFactorTypes: globalThis.Array.isArray(object?.requiredFactorTypes)
                ? object.requiredFactorTypes.map((e) => (0, login_factor_type_1.loginFactorTypeFromJSON)(e))
                : [],
        };
        if (isSet(object.flow)) {
            message.flow = loginFlowFromJSON(object.flow);
        }
        if (isSet(object.requestedFlow)) {
            message.requestedFlow = loginFlowFromJSON(object.requestedFlow);
        }
        if (globalThis.Array.isArray(object?.optionalFactorTypes)) {
            message.optionalFactorTypes = object.optionalFactorTypes.map((e) => (0, login_factor_type_1.loginFactorTypeFromJSON)(e));
        }
        if (isSet(object.supportsUnverifiedAliases)) {
            message.supportsUnverifiedAliases = globalThis.Boolean(object.supportsUnverifiedAliases);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.flow !== undefined && message.flow !== LoginFlow.SIGNUP) {
            obj.flow = loginFlowToJSON(message.flow);
        }
        if (message.requestedFlow !== undefined && message.requestedFlow !== LoginFlow.SIGNUP) {
            obj.requestedFlow = loginFlowToJSON(message.requestedFlow);
        }
        if (message.requiredFactors !== 0) {
            obj.requiredFactors = Math.round(message.requiredFactors);
        }
        if (message.requiredFactorTypes?.length) {
            obj.requiredFactorTypes = message.requiredFactorTypes.map((e) => (0, login_factor_type_1.loginFactorTypeToJSON)(e));
        }
        if (message.optionalFactorTypes?.length) {
            obj.optionalFactorTypes = message.optionalFactorTypes.map((e) => (0, login_factor_type_1.loginFactorTypeToJSON)(e));
        }
        if (message.supportsUnverifiedAliases !== undefined && message.supportsUnverifiedAliases !== false) {
            obj.supportsUnverifiedAliases = message.supportsUnverifiedAliases;
        }
        return obj;
    },
    create(base) {
        return exports.CreateSession.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateSession();
        message.flow = object.flow ?? LoginFlow.SIGNUP;
        message.requestedFlow = object.requestedFlow ?? LoginFlow.SIGNUP;
        message.requiredFactors = object.requiredFactors ?? 0;
        message.requiredFactorTypes = object.requiredFactorTypes?.map((e) => e) || [];
        message.optionalFactorTypes = object.optionalFactorTypes?.map((e) => e) || [];
        message.supportsUnverifiedAliases = object.supportsUnverifiedAliases ?? false;
        return message;
    },
};
function createBaseSessionMetadata() {
    return { isWrongLoginFlow: false };
}
exports.SessionMetadata = {
    fromJSON(object) {
        const message = {
            isWrongLoginFlow: isSet(object.isWrongLoginFlow)
                ? globalThis.Boolean(object.isWrongLoginFlow)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isWrongLoginFlow !== false) {
            obj.isWrongLoginFlow = message.isWrongLoginFlow;
        }
        return obj;
    },
    create(base) {
        return exports.SessionMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSessionMetadata();
        message.isWrongLoginFlow = object.isWrongLoginFlow ?? false;
        return message;
    },
};
function loginFlowFromJSON(object) {
    switch (object) {
        case 0:
        case 'SIGNUP':
            return LoginFlow.SIGNUP;
        case 1:
        case 'RECOVERY':
            return LoginFlow.RECOVERY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return LoginFlow.UNRECOGNIZED;
    }
}
exports.loginFlowFromJSON = loginFlowFromJSON;
function loginFlowToJSON(object) {
    switch (object) {
        case LoginFlow.SIGNUP:
            return 'SIGNUP';
        case LoginFlow.RECOVERY:
            return 'RECOVERY';
        case LoginFlow.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.loginFlowToJSON = loginFlowToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=session.js.map